import { floatify } from 'lib/maths/mathUtils'
import { createSelector } from 'reselect'
import getPartnershipModifierAmount from './getPartnershipModifierAmount'
import getDiscountTotal, { getVoucherDiscountTotal } from './getDiscountTotal'
import getPayableTotal from './getPayableTotal'
import { AGENT_HUB_PAYMENT_MODE } from 'constants/payment'

const getPayableAfterModifiers = createSelector(
  (state: App.State) => getPayableTotal(state),
  (state: App.State) => getDiscountTotal(state),
  (state: App.State) => getVoucherDiscountTotal(state),
  (state: App.State) => getPartnershipModifierAmount(state),
  (state: App.State) => state.checkout.payment.agentHubPaymentMode,
  (payableTotal, promoDiscountAmount, voucherDiscountAmount, partnershipModifierAmount, agentHubPaymentMode): number => {
    const totalDiscount = promoDiscountAmount + voucherDiscountAmount
    if (agentHubPaymentMode === AGENT_HUB_PAYMENT_MODE.PAY_GROSS_AMOUNT) {
      return floatify(payableTotal - partnershipModifierAmount)
    }

    if (totalDiscount > (payableTotal + partnershipModifierAmount)) {
      return 0
    }
    return floatify(payableTotal - totalDiscount - partnershipModifierAmount)
  },
)

export default getPayableAfterModifiers
